import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../shared/context/auth-context";
import {isNumber}  from "../../shared/util/validators";
import { useParams } from "react-router-dom";
import Card from "../../shared/components/UIElements/Card";
import Button from "../../shared/components/formElements/Button";
import Modal from "../../shared/components/UIElements/Modal";
import { useHttpClient } from "../../shared/hooks/http-hook";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import "./OrderInfo.css";
import "tachyons";
import { formatPhoneNumber } from "../../print/page/Print";
import moment from "moment/moment";
import { useWindow } from "../../shared/hooks/window-hook";
const OrderInfo = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const history = useHistory();
  const [deposit, setDeposit] = useState("");

  // const [toggleValue, setToggleValue] = useState(true);
  // const toggler = () => {
  //   setToggleValue(!toggleValue);
  // };
  const [loadedOrder, setLoadedOrder] = useState({
    customer: [""],
    startDate: "",
    eventDate: "",
    orderNumber: "",
    description: "",
    deposit : "",
    items: [""],
    archive: "",
    tax:""
  });
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const orderID = useParams().orderId;

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + `/orders/${orderID}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );

        setLoadedOrder(responseData.order);
      } catch (err) {}
    };
    fetchOrder();
  }, [sendRequest, orderID, auth.token]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmArchive, setShowConfirmArchive] = useState(false);
  const [showConfirmDeposit, setShowConfirmDeposit] = useState(false);
  const showDeleteWarningHandler = (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const cancelDeleteHandler = () => {
    setShowConfirmModal(false);
  };

  const confirmDeleteHandler = async (event) => {
    setShowConfirmModal(false);

    const list = loadedOrder.items;
    const itemsList = list.map((array) => {
      return [array[0]["id"], array[0]["quantity"]];
    });
    itemsList.forEach(async (item) => {
      try {
        await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/orders/increment",
          "PATCH",
          JSON.stringify({
            quantity: item[1],
            id: item[0],
          }),
          {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          }
        );
      } catch (err) {}
    });
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/orders/${orderID}`,
        "DELETE",
        null,
        { Authorization: "Bearer " + auth.token }
      );
      history.push("/orders");
    } catch (err) {}
  };

  const printObj = {
    id: loadedOrder.id,
    customerName:
      loadedOrder.customer.flat()[0].name +
      " " +
      loadedOrder.customer.flat()[0].lastname,
    orders: loadedOrder.items.flat().map((item) => item),
    orderNumber: loadedOrder.orderNumber,
    eventDate: loadedOrder.eventDate.substring(0, 10),
    date: loadedOrder.startDate.substring(0, 10),
    phone: loadedOrder.customer.flat()[0].phone,
    discription: loadedOrder.description,
    salesTax: loadedOrder.tax,
    deposit: loadedOrder.deposit
  };

  const showArchiveWarningHandler = (e) => {
    e.preventDefault()
    setShowConfirmArchive(true);
  };

  const cancelArchiveHandler = () => {
    setShowConfirmArchive(false);
  };

  const confirmArchiveHandler = async () => {
    setShowConfirmArchive(false);
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/orders/${orderID}/archive`,
        "PATCH",
        JSON.stringify({
          archive: loadedOrder.archive,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push("/orders");
    } catch (err) {}
  };
  let SUBTOTAL = 0;
  let DISCOUNT = 0;
  let SALES_TAX = 0;
  

  const cancelDepositHandler = () => {
    setShowConfirmDeposit(false)
  }

  const confirmDepositHandler = () => {
    setShowConfirmDeposit(false)

    //adding code here???????????????????????????????????????
    if ( !isNumber(deposit)) {
      return
    }
    fetch(process.env.REACT_APP_BACKEND_URL + `/orders/${orderID}/deposit`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        date: moment().format("YYYY-MM-DD"),
        deposit: deposit

      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoadedOrder(data.order);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      setDeposit("");
  }

  const showDepositWarningHandler = (event) => {
    event.preventDefault();
    setShowConfirmDeposit(true)
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <Modal
        show={showConfirmModal}
        onCancel={cancelDeleteHandler}
        header="Are you sure?"
        footerClass="order-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDeleteHandler}>
              CANCEL
            </Button>
            <Button danger onClick={confirmDeleteHandler}>
              DELETE
            </Button>
          </React.Fragment>
        }
      >
        <p>
          Do you want to proceed and delete this sales receipt? Please note that
          it can't be undone thereafter.
        </p>
      </Modal>
      <Modal
        show={showConfirmArchive}
        onCancel={cancelArchiveHandler}
        header="Are you sure?"
        footerClass="specialOrders-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelArchiveHandler}>
              CANCEL
            </Button>
            <Button secondary onClick={confirmArchiveHandler}>
              {loadedOrder.archive ? "UNARCHIVE" : "ARCHIVE"}
            </Button>
          </React.Fragment>
        }
      >
        <p>Do you want to proceed and {loadedOrder.archive ? "unarchive" : "archive"} this sales receipt?</p>
      </Modal>

      <Modal
        show={showConfirmDeposit}
        onCancel={cancelArchiveHandler}
        header="Are you sure?"
        footerClass="specialOrders-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDepositHandler}>
              CANCEL
            </Button>
            <Button success onClick={confirmDepositHandler}>
              ADD
            </Button>
          </React.Fragment>
        }
      >
        <p>Do you want to proceed and deposit the amount?</p>
      </Modal>

      {!isLoading && loadedOrder && (
        <li className="orders-info-list">
          <Card className="order-item__content">
          <form >
            <div className="flex justify-between ">
                {/* <div className="flex justify-between"> */}
                  <div className=" w-25">
                    {loadedOrder.archive === false ? "" : "Archive: 📁"}
                  </div>
                  <div className=" w-100 sales-header">
                    <h2 className="tc">Sales Receipt Details</h2>
                  </div>
                  <div className=" w-25 ">
                    <Button
                      reverse
                      to={{ pathname: `/print/${JSON.stringify(printObj).replaceAll('/', ' ')}` }}
                    >
                      🖨️
                    </Button>
                  </div>
                </div>
                <br />
              

                
                <div className="flex justify-center">
                  <div className=" w-50 mr1">
                    <label>Receipt Number</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedOrder.orderNumber}
                    />
                  </div>
                  <div className=" w-50  mr1">
                    <label>Order Date</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedOrder.startDate.substring(0, 10)}
                    />
                  </div>
                  <div className=" w-50  mr1">
                    <label>Event Date</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedOrder.eventDate.substring(0, 10)}
                    />
                  </div>
                </div>

                <div className="flex justify-center">
                  <div className=" w-50 mr1">
                    <label>Name</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedOrder.customer.flat()[0].name}
                    />
                  </div>

                  <div className=" w-50 mr1">
                    <label>Last name</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedOrder.customer.flat()[0].lastname}
                    />
                  </div>
                  <div className=" w-50  mr1">
                    <label>Phone</label>
                    <input
                      readOnly
                      type="text"
                      value={formatPhoneNumber(loadedOrder.customer.flat()[0].phone)}
                    />
                  </div>
                </div>

                <div className="flex items-center ">
                  <div className="tl w-50">
                    <label>Description</label>
                    <textarea                 
                      readOnly
                      value={loadedOrder.description}
                    />
                    
              
                    <div className="flex justify-center">
                      <div className=" w-50  mr1">
                        <label>Deposit</label>
                        <input
                          type="text"
                          value={deposit}
                          onChange={e => setDeposit(e.target.value)}
                        />
                      </div>
                      <div className=" w-50  mr1" style={{marginTop:"32px"}}>
                        <button
                          className="button-3 ml2"
                          onClick={showDepositWarningHandler}
                         >ADD DEPOSIT
                         </button>
                      </div>
                    </div>
                    
                    
                  </div>
                  
       
                  <div className="flex justify-around ">
                  <div className=" w-50  mr1 ">
                    <div className="total">
                      {width > 800 ? <Card className="total-card-salesInfo">
                        <div className="column-total-card">
                          <span className="post-total">
                            SUBTOTAL
                            <br />
                          </span>
                          <span className="post-total">
                            DISCOUNT
                            <br />
                          </span>
                          <span className="post-total">
                            SALES TAX
                            <br />
                          </span>
                          {loadedOrder.deposit && loadedOrder.deposit !== "0" && (
                              <span className="post-total">
                            DEPOSIT
                            <br />
                          </span>)}
                          <span className="post-total">
                            TOTAL
                            <br />
                          </span>

                          <br />
                          BALANCE
                        </div>
                        <div className="column-total-card">
                          <span className="post-total">
                            $
                            <div className="sub-total-card">
                              {(SUBTOTAL += loadedOrder.items
                                .flat()
                                .reduce((acc, item) => {
                                  return acc + item.price * item.quantity;
                                }, 0)).toFixed(2)}
                            </div>
                          </span>
                        </div>
                        <div className="column-total-card">
                          <span className="post-total">
                            $
                            <div className="sub-total-card">
                              {(DISCOUNT += loadedOrder.items
                                .flat()
                                .reduce((acc, item) => {
                                  return (
                                    acc +
                                    (item.price *
                                      item.quantity *
                                      item.discount) /
                                      100
                                  );
                                }, 0)).toFixed(2)}
                            </div>
                          </span>
                        </div>
                        {loadedOrder.tax === "on" ? (
                          <div className="column-total-card">
                            <span className="post-total">
                              $
                              <div className="sub-total-card">
                                {(SALES_TAX +=
                                  ((SUBTOTAL - DISCOUNT) * 9.5) / 100).toFixed(
                                  2
                                )}
                              </div>
                            </span>
                          </div>
                        ) : (
                          <div className="column-total-card">
                            <span className="post-total">
                              $
                              <div className="sub-total-card">
                                {(0).toFixed(2)}
                              </div>
                            </span>
                          </div>
                        )}

                         {loadedOrder.deposit && loadedOrder.deposit !== "0" && (
                          <div className="column-total-card">
                          <span className="post-total">
                            $
                            <div className="sub-total-card">
                              {Number(loadedOrder.deposit).toFixed(2)}
                            </div>
                          </span>
                        </div>
                         )                  
                         }
                         {loadedOrder.tax === "on" ? (
                          <div className="column-total-card">
                            <span className="post-total">
                              $
                              <div className="sub-total-card">
                              {(SUBTOTAL - DISCOUNT + SALES_TAX ).toFixed(2)}
                            
                              </div>
                            </span>
                          </div>
                        ) : (
                          <div className="column-total-card">
                            <span className="post-total">
                              $
                              <div className="sub-total-card">
                              {(SUBTOTAL - DISCOUNT).toFixed(2)}
                           
                              </div>
                            </span>
                          </div>
                        )}

                        {loadedOrder.tax === "on" ? (
                          <div className="column-total-card">
                            <br />$
                            <div className="sub-total-card">
                              {(SUBTOTAL - DISCOUNT + SALES_TAX - Number(loadedOrder.deposit)).toFixed(2)}
                            </div>
                          </div>
                        ) : (
                          <div className="column-total-card">
                            <br />$
                            <div className="sub-total-card">
                              {(SUBTOTAL - DISCOUNT - Number(loadedOrder.deposit)).toFixed(2)}
                            </div>
                          </div>
                        )}
                      </Card> : ""}
                      
                    </div>

                  </div>
                  </div>
                </div>
                
                  {/*<div className=" w-50  mr1">
                     tax toggle
                     <label>TAX: </label>
                    <label className="switch">
                      <input
                        type="checkbox"
                        onClick={toggler}
                        value={toggleValue}
                      />
                      <span className="slider"></span>
                    </label> 
                  </div>*/}
            <table className={width > 800 ? "items-table mt2" : ""}>
              <tbody>
                <tr>
                  <th>Style#</th>
                  <th>Company</th>
                  <th>Color</th>
                  <th>US Size</th>
                  <th>EUR Size</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
                {loadedOrder.items.flat().map((item) => {
                  return (
                    <tr key={item.orderNumber + item.style}>
                      <td>{item.style}</td>
                      <td>{item.company}</td>
                      <td>{item.color}</td>
                      <td>{item.USSize}</td>
                      <td>{item.EURSize}</td>
                      {<td>{item.quantity}</td>}
                      <td>{"$" + item.price}</td>
                    </tr>
                  );
                })}
                
              </tbody>
            </table>
            <div className="orders-item__actions">
              <Button inverse to="/orders">
                BACK
              </Button>
              {width > 800 ? <Button to={`/orders/${orderID}/edit`}>EDIT</Button> : ""}
              <Button danger onClick={showDeleteWarningHandler}>
                DELETE
              </Button>
              <Button secondary onClick={showArchiveWarningHandler}>
                {loadedOrder.archive ? "UNARCHIVE" : "ARCHIVE"}
              </Button>
            </div>
            </form>
          </Card>
        </li>
      )}
      <FloatingButton icon={"back"} />
    </React.Fragment>
  );
};

export default OrderInfo;
